<template>
    <div class="n-m-auto"
         :class="{'c-max-width n-plr-2 n-mt-3': !pageInner, 'n-flex-g': pageInner}">
        <div v-if="loading"
             class="n-h-1 n-bg-1 n-p-3">
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-2"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>

            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3 n-col-2"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>

            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3 n-col-2"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
        </div>

        <div v-else
             class="n-bg-1 n-radius-10"
             :class="{'n-p-4': !pageInner}">
            <h1 class="c-f-1 n-f-bold n-m-0"
                v-if="data.title"
                v-html="data.title"></h1>

            <span class="n-c-2 n-block n-ptb-1 n-b-line"
                  v-if="data.publishDate">{{LAN.news.publishDate}} {{ data.publishDate }}</span>

            <div v-if="data.fContent"
                 class="n-mt-6">
                <div v-html="data.fContent || '-'"></div>
            </div>

            <div class="n-mt-6"
                 v-if="data.attachList?.length > 0">
                <ul class="n-ul n-p-0 n-m-0 n-ptb-4">
                    <li v-for="(item, index) in data.attachList"
                        :key="index">
                        <a href="javascript:;"
                           class="c-tab-link c-tab-link-event n-flex n-flex-a-c n-pointer n-f-underline n-ptb-1"
                           @click="previewData = item">
                            <span><i class="n-icon n-icon-link n-inline-block n-icon-size-15 n-mr-1"></i>{{ item.name }}</span></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <a-modal v-model:visible="previewData"
             centered
             width="calc(100vw - 10px)"
             height="calc(100vh - 10px)"
             class="pdf-dialog"
             v-if="!!previewData"
             :bodyStyle="{padding: 0}"
             :title="previewData.name"
             :footer="null"
             @ok="previewData = null">
        <DocView :url="previewData.url"
                 :name="previewData.name"
                 class="pdf"></DocView>
    </a-modal>
</template>
<script>
    import { mapMutations, mapState } from "vuex";

    import nui from "@/assets/script";
    import DocView from '@/components/nui/DocView/DocView.vue'

    export default {
        name: "NewsDetailCmp",
        props: {
            id: String,
            pageInner: Boolean
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        watch: {
            id () {
                this.loadData()
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                data: {},
                previewData: null
            });
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),
            NActivated () {
            },
            NMounted () {
                this.loadData()
            },
            preview (data) {
                this.previewData = data;
            },
            loadData () {
                this.loading = true;

                return this.request(this.API.getCMSDetail, {
                    requestId: "getCMSDetail",
                    params: {
                        id: this.id
                    },
                }).then((res) => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.data = res.data
                    }

                    this.loading = false;

                    this.$nextTick(() => {
                        this.parseMathJax();
                    });
                });
            },
        }),
        components: {
            DocView,
        },
        ...nui.extendVue.extendLife,
    };
</script>
<style lang="scss">
    .pdf-dialog {
        max-width: 100% !important;

        .ant-modal-header {
            background: rgba(56, 56, 61, 1);
            padding: 10px;
            height: 40px;
            border-bottom: 0;
        }

        .ant-modal-title {
            color: $font-color-1;
        }

        .ant-modal-close-x {
            color: $font-color-1;
            width: 40px;
            height: 40px;
            line-height: 40px;
        }

        .ant-modal-content {
            height: 100%;
        }

        .ant-modal-body {
            height: calc(100% - 40px);
        }
    }
</style>
